import { useMemo } from 'react'

import {
  IContactCommonFormRequiredFields,
  IContactCommonFormValidation,
} from 'clickNgo/entities/contact'

interface IUseCommonStepValidationResult
  extends IContactCommonFormRequiredFields,
    IContactCommonFormValidation {}

export function useCommonStepValidation(): IUseCommonStepValidationResult {
  return useMemo(
    () => ({
      isWorkPhoneCodeRequired: true,
      isWorkPhoneNumberRequired: true,
    }),
    []
  )
}
